import { render, staticRenderFns } from "./SelectCase.vue?vue&type=template&id=020e9082"
import script from "./SelectCase.vue?vue&type=script&lang=js"
export * from "./SelectCase.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports